import React from 'react';

const UnderenhetIkon = () => (
    <svg className="underenhet-ikon" width="14px" height="19px" version="1" xmlns="http://www.w3.org/2000/svg">
        <title>Bedrift</title>
        <g
            stroke="black"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M11 16H1V1h10z" />
            <path d="M6 13H3v3h3zM1 3h4M1 5h3M1 7h2" />
        </g>
    </svg>
);

export default UnderenhetIkon;
